import { Renderer2 } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { PdfPageManager } from '../pdf-page-manager/pdf-page-manager';
import { Environment } from '../../../../models/environment';

pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdfjs-lib/pdf.worker.min.js';

export class PdfDocumentManager {
    public readonly PDF_MINIMUM_SCALE = 1.5;
    private _documentId: string;
    private _pageManagerList: PdfPageManager[] = [];
    private _documentBuffer: Uint8Array | string;
    private _proxy: PDFDocumentProxy;

    constructor(
        private _environment: Environment,
        private _renderer: Renderer2,
        public bufferArray: Uint8Array | string
    ) {
        this._documentBuffer = bufferArray;
    }

    get proxy(): PDFDocumentProxy {
        return this._proxy;
    }

    get documentId(): string {
        return this._documentId;
    }

    set documentId(id: string) {
        this._documentId = id;
    }

    get pageManagerList(): PdfPageManager[] {
        return this._pageManagerList;
    }

    async getDocumentProxy(): Promise<PDFDocumentProxy> {
        try {
            if (!this._documentBuffer) {
                throw new Error('PDF document buffer is empty');
            }
            this._proxy = await pdfjsLib.getDocument(this._documentBuffer).promise;
        } catch (e) {
            const message = e instanceof Error ? e.message : 'Unknown error';
            throw new Error(`Something went wrong on - getDocumentProxy - ${message}`);
        }

        if (!this._proxy) {
            throw new Error('Something went wrong on - getDocumentProxy - empty proxy');
        }

        return this._proxy;
    }

    async handlePdfPageManagerOperations(
        pageManager: PdfPageManager,
        i: number,
        callback: (img: HTMLImageElement) => void): Promise<void> {
        try {
            await pageManager.getPageProxy(i);
            await pageManager.renderPdfPage(i);
            await pageManager.handleImageOnLoad(callback);
            await pageManager.getPageAnnotations();
            pageManager.handleCustomAnnotations();
            this._pageManagerList.push(pageManager);
        } catch (e) {
            throw new Error('Something went wrong on -handlePdfPageManagerOperations-');
        }
    }

    getPageManagerOperations(range: number[], callback: (img: HTMLImageElement) => void): unknown[] {
        let promisesArray = [];

        for (let i = range[0]; i <= range[range.length - 1]; i++) {
            const pageManager = new PdfPageManager(this._environment, this._renderer, this._proxy, i);
            promisesArray.push(this.handlePdfPageManagerOperations(pageManager, i, callback));
        }

        return promisesArray;
    }
}
